/**
 * A real (non-anonymous) Firebase session is the source of truth for the session identity:
 * its ID token is what the interceptor sends. When the store has no user, or still holds a
 * Dood guest, the store must be reloaded from /users/me with that token. Otherwise the user
 * signs up or continues as a guest on top of their existing account, and the API rejects
 * requests that carry the store user id (DOOD-3495).
 */
export function shouldRestoreSessionUser(
  firebaseUser: { isAnonymous: boolean } | null | undefined,
  storeUser: { is_anonymous?: boolean | null } | null | undefined,
): boolean {
  if (!firebaseUser || firebaseUser.isAnonymous) {
    return false;
  }
  return !storeUser || !!storeUser.is_anonymous;
}
